var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 95,
    viewBox: "0 0 97 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2524 94.332V20.48H3.26041V94.332H11.2524ZM7.25641 0.647998C4.00041 0.647998 0.892405 3.75599 0.892405 7.012C0.892405 10.416 4.00041 13.376 7.25641 13.376C10.5124 13.376 13.6204 10.416 13.6204 7.012C13.6204 3.75599 10.5124 0.647998 7.25641 0.647998ZM69.1435 20.628C60.1155 20.628 51.8275 25.216 49.6075 28.176V20.776H41.7635V46.676H41.9115C41.9115 45.788 41.7635 46.38 41.7635 47.268V94.48H49.6075V47.268C49.6075 36.76 58.1915 28.62 69.1435 28.62C80.2435 28.62 88.6795 36.76 88.6795 47.268V94.48H96.6715V47.268C96.6715 32.764 84.0915 20.628 69.1435 20.628Z",
    fill: "#FEC736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/IN.0912967598a777f80c1e17d47ad765ed.svg";
export { ForwardRef as ReactComponent };